<template>
    <b-list-group-item>
        <b-icon v-if="!error" icon="journal" class="mr-2"></b-icon>
        <b-link v-if="error" v-b-toggle="'collapse-'+idKey" class="text-danger mr-2" size="sm">
            <b-icon class="when-opened" icon="journal-minus"></b-icon>
            <b-icon class="when-closed" icon="journal-plus"></b-icon>
        </b-link>
        {{ label }} :
        <span v-if="!message" :class="isAlive ? 'text-success' : 'text-danger'">{{ isAlive ? "OK" : "KO" }}</span>
        <span v-if="message" :class="isAlive ? 'text-success' : 'text-danger'">{{ isAlive }}</span>
        <b-collapse :id="'collapse-'+idKey" class="mt-2">
            <b-alert variant="danger" show>{{ error }}</b-alert>
        </b-collapse>
        <b-overlay :show="isAlive == null" spinner-variant="primary" spinner-type="grow" spinner-small no-wrap/>
    </b-list-group-item>
</template>

<script>
export default {
    name: "MonitoringLine",
    props: {
        idKey: String,
        error: [Object, Error, String],
        isAlive: [Boolean, String],
        message: Boolean,
        label: String
    },
}
</script>

<style scoped>

</style>